import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useModal } from "@/components/essex/ModalContext";

const navLinks = [
  { label: "Home", href: "/" , isRoute: true },
  { label: "Why Us", href: "/why-us", isRoute: true },
  { label: "Films", href: "#films" },
  { label: "Services", href: "#services" },
  { label: "Venues", href: "#venues" },
  { label: "Packages", href: "/video-photo", isRoute: true },
  { label: "Guide", href: "/guide", isRoute: true },
  { label: "About", href: "/about", isRoute: true },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { openModal } = useModal();
  const location = useLocation();
  const navigate = useNavigate();

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);

    if (location.pathname === "/" || location.pathname === "/essex") {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: href } });
    }
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 glass-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="header-logo"
          className="font-serif text-xl tracking-tight text-[#F5F5F0] hover:text-[#C2A878] transition-colors"
        >
          Wedding Video <span className="text-[#C2A878]">Essex</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav" aria-label="Main navigation">
          {navLinks.map((link) =>
            link.isRoute ? (
              <Link
                key={link.label}
                to={link.href}
                className="text-sm font-sans tracking-wide text-[#A19D94] hover:text-[#F5F5F0] transition-colors duration-300"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
                className="text-sm font-sans tracking-wide text-[#A19D94] hover:text-[#F5F5F0] transition-colors duration-300"
              >
                {link.label}
              </a>
            )
          )}
          <button
            onClick={openModal}
            data-testid="header-check-date-btn"
            className="text-xs tracking-[0.15em] px-5 py-2 border border-[#C2A878]/30 text-[#C2A878] hover:bg-[#C2A878]/10 transition-all duration-300 font-sans"
          >
            Check My Date
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#F5F5F0]"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-nav"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((link) =>
              link.isRoute ? (
                <Link
                  key={link.label}
                  to={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-base font-sans text-[#A19D94] hover:text-[#F5F5F0] transition-colors"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleAnchorClick(e, link.href)}
                  className="text-base font-sans text-[#A19D94] hover:text-[#F5F5F0] transition-colors"
                >
                  {link.label}
                </a>
              )
            )}
            <button
              onClick={() => { openModal(); setMobileOpen(false); }}
              className="text-sm font-sans text-[#C2A878] text-left"
            >
              Secure Your Date
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
